<div class="dropdown-cont" #dropdownContainer (click)="toggleNav()" [class.opened]="openMenu">
  <div class="user-profile-icon">
    <img [src]="accountData?.photo?.url1x || '/assets/icons/profile-icon.png'" class="profile-icon" />
  </div>
</div>

<div class="dropdown-menu" [class.opened]="openMenu">
  <ul>
    <li (click)="saveProfile()" *ngIf="dataLoaded && !accountData.password_created" [class.disabled]="!isActivated">
      <div class="img-cont"><img src="/assets/icons/change-password-icon.svg" class="menu-icon" /></div>
      {{ 'auth.create_your_password' | translate }}
    </li>
    <li (click)="changePassword()" *ngIf="dataLoaded && accountData.password_created" [class.disabled]="!isActivated">
      <div class="img-cont"><img src="/assets/icons/change-password-icon.svg" class="menu-icon" /></div>
      {{ 'auth.change_password' | translate }}
    </li>
    <li (click)="deleteAccount()" [class.disabled]="!isActivated">
      <div class="img-cont"><img src="/assets/icons/delete-icon.svg" class="menu-icon" /></div>
      {{ 'global.delete_account' | translate }}
    </li>
    <li (click)="logout()" [class.disabled]="!isActivated">
      <div class="img-cont"><img src="/assets/icons/logout-icon.svg" class="menu-icon" /></div>
      {{ 'global.logout' | translate }}
    </li>
  </ul>
</div>

<div class="edit-container" *ngIf="showDeleteConfirm">
  <div class="edit-in-container">
    <bwc-confirm-delete-account (emitClose)="showDeleteConfirm = false" class="fixed-size"></bwc-confirm-delete-account>
  </div>
</div>
